export default __webpack_public_path__ + "static/media/Patriotic-Wire-Wrapped-Bracelet.aa594374.jpg";